module.exports = {
	"name": "youboralib",
	"type": "lib",
	"tech": "js",
	"author": "Jordi Aguilar",
	"version": "6.0.4",
	"built": "2017-07-10",
	"repo": "https://bitbucket.org/npaw/lib-plugin-js.git"
};


//////////////////
// WEBPACK FOOTER
// ./~/youboralib/manifest.json
// module id = 27
// module chunks = 0